// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ManualOrder from '../components/ManualOrder';
import {actions as ManualOrderActions} from '../duck';

import {actions as PromotionActions} from '../../marketing/promotions/duck';

import type {RootState} from '../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    store: state.store.store,
    products: state.manualOrder.products,
    isFetchingProducts: state.manualOrder.isFetchingProducts,
    pagination: state.manualOrder.pagination,
    shoppingCart: state.manualOrder.shoppingCart,
    currency: state.currency.currency,
    categories: state.categories.categories,
    itemPrices: state.manualOrder.itemPrices,
    subTotal: state.manualOrder.subTotal,
    total: state.manualOrder.total,
    coupon: state.manualOrder.coupon,
    couponDiscount: state.manualOrder.couponDiscount,
    promotions: state.manualOrder.promotions,
    createOrderSuccess: state.manualOrder.createOrderSuccess,
    order: state.manualOrder.order,
    storePromotions: state.promotions.promotions,
    globalDiscountData: state.manualOrder.globalDiscountData,
    error: state.manualOrder.error,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...ManualOrderActions,
        ...PromotionActions,
      },
      dispatch
    )
)(ManualOrder);
